import Reveal from "./Reveal";
import { IMG } from "../data/content";

const CELLS = [
  { src: IMG.lobby, caption: "The Grand Lobby", sub: "Hand-carved walnut ceiling", cls: "col-span-2 row-span-2" },
  { src: IMG.bedroom, caption: "Walnut Bedrooms", sub: "Warm cove lighting", cls: "" },
  { src: IMG.bathroom, caption: "Marble Baths", sub: "Backlit mirrors", cls: "" },
  { src: IMG.lounge, caption: "In-room Lounges", sub: "Tea atelier & smart TV", cls: "" },
  { src: IMG.reception, caption: "Concierge Desk", sub: "At your service, always", cls: "" },
];

const STATS = [
  { value: "30+", label: "Crafted Rooms" },
  { value: "4.9", label: "Guest Rating" },
  { value: "10 min", label: "To Airport" },
  { value: "15 min", label: "To Dal Lake" },
];

const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="border-t border-[#2A2421] bg-[#161311] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="mb-14 grid gap-10 lg:grid-cols-2 lg:items-end">
          <div>
            <p className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#C5A059]">The Craft</p>
            <h2 className="mt-4 font-display text-4xl font-light leading-tight text-[#F5F2EB] sm:text-5xl">
              An Address of <em className="text-[#C5A059]">Rare Craft</em>
            </h2>
          </div>
          <div>
            <p className="text-sm leading-relaxed text-[#A8A29E]">
              Kashmir's master woodcarvers spent months on our ceilings and panelling. Every photograph here is The
              Rayan itself — no staging, no stock.
            </p>
            <div className="mt-6 grid grid-cols-4 gap-4">
              {STATS.map((s) => (
                <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  <p className="font-display text-2xl text-[#C5A059] sm:text-3xl">{s.value}</p>
                  <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#78716C]">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>

      <div className="grid auto-rows-[160px] grid-cols-2 gap-3 sm:auto-rows-[200px] md:grid-cols-4">
        {CELLS.map((c, i) => (
          <Reveal key={c.caption} delay={i * 0.08} className={c.cls}>
            <figure data-testid={`gallery-item-${i}`} className="group relative h-full w-full overflow-hidden border border-[#2A2421]">
              <img
                src={c.src}
                alt={c.caption}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
              />
              <figcaption className="absolute inset-x-0 bottom-0 translate-y-3 bg-gradient-to-t from-[#0D0B0A]/90 to-transparent p-4 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <p className="font-display text-lg text-[#F5F2EB]">{c.caption}</p>
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">{c.sub}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
